<template>
    <ak-form-decorator
        :title="title"
        :value="value"
    >
        <a :href="value" target="_blank">{{ value }}</a>
    </ak-form-decorator>
</template>

<script>
export default {
    name: 'ak-read-only-link',
    props: {
        value: {
            type: String
        },
        title: {
            type: String,
        }
    }
};
</script>
